var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('mcs-btn',{staticClass:"mr-3 px-4 bg-white",attrs:{"color":"black","outlined":"","prependIcon":"mdi-account-group"},on:{"click":_vm.click}},[_vm._v(" Invite ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }